import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { content } from "../data/content";
import { Code } from "lucide-react";

const Experience = () => {
  const { lang } = useLanguage();
  const t = content[lang].experience;

  return (
    <section className="py-12">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-xl font-semibold mb-8 text-muted-foreground uppercase tracking-wider text-sm border-b border-border pb-4">
          {t.title}
        </h2>
        
        <div className="space-y-6">
          {t.items.map((item, index) => (
             <div key={index} className="flex items-start gap-4 p-6 -mx-6 hover:bg-secondary/20 rounded-2xl transition-colors">
                <div className="w-12 h-12 rounded-xl bg-secondary/30 flex items-center justify-center shrink-0 border border-transparent">
                     <Code className="w-6 h-6 text-foreground" />
                </div>
                
                <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between mb-2">
                        <h3 className="text-xl font-semibold text-foreground">
                            {item.title}
                        </h3>
                        <span className="text-sm font-mono text-muted-foreground bg-secondary/50 px-2 py-1 rounded">
                          {item.subtitle}
                        </span>
                    </div>
                    <div className="text-base text-muted-foreground">
                        {item.desc}
                    </div>
                </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
